<!--赖传峰-->
<!--2021/12/15-->
<template>
  <span
    ref="icon"
    :class="[
      props.spin && 'pp-spin',
      props.hoverAble && 'icon-hover-able',
      pointer && 'pp-pointer',
      disabled && 'pp-disabled',
    ]"
    :style="[
      props.style,
      {
        '--icon-color': color,
        '--icon-color-hover': hoverColor,
        flex: `0 0 ${props.size}px`,
        width: props.size + 'px',
        height: props.size + 'px'
      }
    ]"
    class="pp-icon"
  >
    <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <slot />
    </svg>
  </span>
</template>

<script
  lang="ts"
  setup
>
import { computed } from '#imports'
import iconPropsType from './iconPropsType'

const props = defineProps(iconPropsType)
const color = computed(() => props.color)
const hoverColor = computed(() => props.hoverColor)

</script>
<style
  lang="less"
  scoped
>
.pp-icon {
  display: flex;
  color: var(--icon-color, --color-secondary-text);

  &.icon-hover-able {
    transition: all var(--transition-delay) var(--transition-animation);

    &:not(.pp-disabled):hover {
      /* color: v-bind(hoverColor); */
      color: var(--icon-color-hover, --color-primary);
    }
  }
}

.pp-pointer {
  cursor: pointer;
}

.pp-disabled {
  cursor: not-allowed;
}

*:hover {
  > :not(.pp-disabled).pp-icon.icon-hover-able {
    /* color: v-bind(hoverColor); */
    color: var(--icon-color-hover, --color-primary);
  }
}
</style>
